"use client";

// F36 (B3.5) — CART-CHROME COHERENCE. Mounts the real, store-driven cart tray and makes the captured
// mirror cart control real on ANY B3 page (browse, supplier detail, mountain profile, product-type
// sub-page — every one carries the hub-header button[aria-label="Open cart"]). Click opens the tray;
// the MuiBadge count is synced from the session store. The captured markup stays byte-identical — 0
// items shows the captured "0"+MuiBadge-invisible state, so the pixel gate is untouched.
//
// The session store persists across navigations, so a cart built on a supplier-detail page is coherent
// everywhere: the badge, the tray and Checkout work from browse, profile and every other B3 page. Only
// the per-product booking widgets stay detail-only (those pages are the only ones with products to add).

import { useEffect } from "react";
import { useCartStore } from "@/lib/cart-store";
import CartTray from "./CartTray";

export default function MarketplaceCartLayer() {
  useEffect(() => {
    // Document-scoped: works whether the chrome is a real component (browse/detail) or full mirror.
    const openBtns = Array.from(document.querySelectorAll<HTMLElement>('[aria-label="Open cart"]'));
    const badges = Array.from(
      document.querySelectorAll<HTMLElement>(
        '[aria-label="Open cart"] .MuiBadge-badge, [class*="HeaderCart"] .MuiBadge-badge',
      ),
    );
    const onOpen = (e: Event) => {
      e.preventDefault();
      useCartStore.getState().setOpen(true);
    };
    for (const b of openBtns) {
      b.style.cursor = "pointer";
      b.addEventListener("click", onOpen);
    }
    const sync = () => {
      const count = useCartStore.getState().items.length;
      for (const badge of badges) {
        badge.textContent = String(count);
        badge.classList.toggle("MuiBadge-invisible", count === 0);
      }
    };
    sync();
    const unsub = useCartStore.subscribe(sync);
    return () => {
      unsub();
      for (const b of openBtns) b.removeEventListener("click", onOpen);
    };
  }, []);

  return <CartTray />;
}
